import { produce } from "immer";
import { v4 } from "uuid";

import { OnsiteEditDto } from "@intelligems/ig-types";
import { AppListenerMiddleware } from "@src/store";
import { selectedOnsiteEdits } from "@src/store/slices/onsiteEdits";
import {
  addVariation,
  deleteVariation,
  selectedVariations,
} from "@src/store/slices/variations";

import { setOfferTestOnsiteEdits } from "../onsiteEdits";

export function setupOnsiteEditsListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: addVariation,
    effect: (action, { dispatch, getState }) => {
      const allOnsiteEdits = selectedOnsiteEdits(getState());
      const variations = selectedVariations(getState());
      const newVariation = variations.find((v) => v.id === action.payload);

      if (
        !newVariation ||
        allOnsiteEdits.length === 0 ||
        variations.length === 0
      )
        return;

      const variationToDuplicate = variations.find(
        (variation) => variation.isControl
      );

      if (!variationToDuplicate) return;

      const onsiteEditsToDuplicate = allOnsiteEdits.filter(
        (onsiteEdit) => onsiteEdit.variationId === variationToDuplicate?.id
      );

      if (onsiteEditsToDuplicate.length > 0) {
        const newOnsiteEdits: OnsiteEditDto[] = onsiteEditsToDuplicate.map(
          (onsiteEdit) => ({
            ...onsiteEdit,
            id: v4(),
            variationId: newVariation.id,
          })
        );

        dispatch(
          setOfferTestOnsiteEdits({
            onsiteEdits: newOnsiteEdits,
            variationId: newVariation.id,
          })
        );
      }
    },
  });
}
